var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEndPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.006,
    height: 88.595,
    viewBox: "0 0 69.006 88.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189891",
    "data-name": "Group 189891",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M105.006,47.766v54.025a5.8,5.8,0,0,1-5.8,5.8H45.8a5.8,5.8,0,0,1-5.8-5.8V39.832L56.252,23H99.2a5.8,5.8,0,0,1,5.8,5.8v5.549",
    transform: "translate(-40 -23)",
    fill: "none",
    stroke: "#6f2f87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M40.56,40.252H56.812V24",
    transform: "translate(-40.235 -23.42)",
    fill: "none",
    stroke: "#6f2f87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M61,125.11h40.629",
    transform: "translate(-48.811 -65.844)",
    fill: "none",
    stroke: "#f26e14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M61,105h40.629",
    transform: "translate(-48.811 -57.406)",
    fill: "none",
    stroke: "#f26e14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 40.629,
    transform: "translate(12.189 35.922)",
    fill: "none",
    stroke: "#f26e14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("text", {
    id: "Dashboard",
    transform: "translate(32.588 26.806)",
    fill: "#6a3089",
    fontSize: 10,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Last")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEndPage);
export default __webpack_public_path__ + "static/media/icon-end-page.5d3a64d8fd1f58d5dd6f8e6623c64826.svg";
export { ForwardRef as ReactComponent };